/* eslint-disable eqeqeq */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Paper } from "@material-ui/core";
import {
  FilteringState,
  GroupingState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  PagingPanel,
  Table,
  TableFilterRow,
  TableHeaderRow,
} from "@devexpress/dx-react-grid-material-ui";

class F301GeneralDiscountReportTableComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [],
      rows: [],
      formatColumns: [],
      currencyColumns: [],
      availableFilterOperations: [
        "equal",
        "notEqual",
        "greaterThan",
        "greaterThanOrEqual",
        "lessThan",
        "lessThanOrEqual",
      ],
      pageSizes: [5, 10, 15, 20],
      defaultSorting: [],
      sortingStateColumnExtensions: [
        { columnName: "action", sortingEnabled: false },
        { columnName: "statusLabel", sortingEnabled: false },
      ],
      tableColumnExtensions: [
        { columnName: "Category", wordWrapEnabled: true },
        { columnName: "product", wordWrapEnabled: true },
        { columnName: "statusLabel", wordWrapEnabled: true },
      ],
      defaultColumnWidths: [],
      resizingMode: "widget",
      defaultFilters: [],
      filteringStateColumnExtensions: [
        { columnName: "action", filteringEnabled: false },
      ],
    };
  }

  CustomRow = ({ row, ...restProps }) => {
    const backgroundColor =
      row.isActive == 1
        ? row.statusId == 3
          ? "#ffe2e2" // Red for statusId = 3
          : row.statusId == 2
          ? "#fef5e9"
          : "transparent"
        : "transparent"; // Default color

    return (
      <Table.Row
        {...restProps}
        style={{
          backgroundColor,
        }}
      />
    );
  };

  render() {
    const {
      tableColumnExtensions,
      defaultSorting,
      sortingStateColumnExtensions,
      filteringStateColumnExtensions,
      defaultFilters,
      pageSizes,
    } = this.state;

    const rows = this.props.data;
    const columns = this.props.columns;
    const showFilter = this.props.showFilter;

    return (
      <Paper>
        <Grid rows={rows} columns={columns}>
          <FilteringState
            defaultFilters={defaultFilters}
            columnExtensions={filteringStateColumnExtensions}
          />
          <SortingState
            defaultSorting={defaultSorting}
            columnExtensions={sortingStateColumnExtensions}
          />
          <GroupingState defaultGrouping={[{ columnName: "product" }]} />
          <PagingState defaultPageSize={10} />
          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />
          <Table
            rowComponent={this.CustomRow}
            columnExtensions={tableColumnExtensions}
          />
          <TableHeaderRow
            showSortingControls={true}
            titleComponent={(props) =>
              props.children != "Action" ? (
                <b>{props.children}</b>
              ) : (
                <b>&emsp;{props.children}</b>
              )
            }
          />
          {showFilter ? <TableFilterRow showFilterSelector={true} /> : ""}
          <PagingPanel pageSizes={pageSizes} />
        </Grid>
      </Paper>
    );
  }
}

F301GeneralDiscountReportTableComponent.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  showFilter: PropTypes.bool,
};

F301GeneralDiscountReportTableComponent.defaultProps = {
  data: [],
  columns: [],
  showFilter: false,
};

export default F301GeneralDiscountReportTableComponent;
